import {AxiosResponse} from 'axios';

import {Route} from 'vue-router';
import DataSource from 'devextreme/data/data_source';

import base_ds, {CrudOperates} from '@/services/base_datasource_service'
import {IBaseEntity} from '@/data_types';
import request from '@/utils/request';
import _ from "lodash";

export const days = [
  {value: 1, name: 'понедельник', short_name: "пн"},
  {value: 2, name: 'вторник', short_name: "вт"},
  {value: 3, name: 'среда', short_name: "ср"},
  {value: 4, name: 'четверг', short_name: "чт"},
  {value: 5, name: 'пятница', short_name: "пт"},
  {value: 6, name: 'суббота', short_name: "сб"},
  {value: 7, name: 'воскресенье', short_name: "вс"}];

class BaseEntity implements IBaseEntity {
  id: string | undefined = undefined;
  deleted: boolean | null = null;
  modified_by_id: string | null | undefined = undefined;
  date_created: string | null | undefined = undefined;
  created_by_id: string | null | undefined = undefined;
  date_modified: string | null | undefined = undefined;
}

export const user_route_ns = 'admin/user'
export const user_logs_route_ns = 'admin/user/logs'

class SingletonService {
  userDataSource: DataSource;
  userLogsDataSource: DataSource;
  breadCrumbs: any[]

  constructor() {
    this.userLogsDataSource = base_ds.getBaseDataSource(user_logs_route_ns);
    this.userDataSource = base_ds.getBaseDataSource(user_route_ns);
  }

  getBreadCrumbs(route: Route) {
    const breadCrumbs: any[] = []
    const topology = {
      path: '/topology',
      name: 'topology',
      meta: {
        title: 'Топология'
      }
    }

    breadCrumbs.push(topology)

    this.breadCrumbs = breadCrumbs
  }

  setBreadCrumbs(breadCrumbs: any[]) {
    this.breadCrumbs = breadCrumbs
  }

}

export default new SingletonService();
